import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { useI18nContext } from '@procore/core-react';
import { useStyles } from './FrequentlyAskedQuestions.styles';
import FrequentlyAskedQuestionsAccordion from './FrequentlyAskedQuestionsAccordion';
import GoogleFrequentlyAskedQuestionsScript from '../Google/GoogleFrequentlyAskedQuestionsScript';
import { type FaqData } from '../../helpers/generate-faqs';

interface FrequentlyAskedQuestionsProps {
  faqs: FaqData[];
}

const FrequentlyAskedQuestions = ({ faqs }: FrequentlyAskedQuestionsProps) => {
  const I18n = useI18nContext();
  const classes = useStyles();
  const middle = Math.floor((faqs.length - 1) / 2) + 1;

  return (
    <Box className={classes.whiteBackground}>
      <Box className={classes.container}>
        <Typography component="h2" className={classes.title}>
          {I18n.t('components.frequently_asked_questions.title')}
        </Typography>
        <GoogleFrequentlyAskedQuestionsScript faqs={faqs} />
        <Box className={classes.accordionContainer}>
          {faqs.map((item) => (
            <FrequentlyAskedQuestionsAccordion
              key={item.key}
              location={item.location}
              questionKey={item.questionKey}
              summary={item.name}
              details={item.acceptedAnswer}
            />
          ))}
        </Box>
        <Grid container spacing={8} className={classes.gridContainer}>
          <Grid item xs={6} style={{ width: 680 }}>
            {faqs.slice(0, middle).map((item) => (
              <FrequentlyAskedQuestionsAccordion
                key={item.key}
                location={item.location}
                questionKey={item.questionKey}
                summary={item.name}
                details={item.acceptedAnswer}
              />
            ))}
          </Grid>
          <Grid item xs={6} style={{ width: 680 }}>
            {faqs.slice(middle, faqs.length).map((item) => (
              <FrequentlyAskedQuestionsAccordion
                key={item.key}
                location={item.location}
                questionKey={item.questionKey}
                summary={item.name}
                details={item.acceptedAnswer}
              />
            ))}
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
};

export default FrequentlyAskedQuestions;

export interface FAQItem {
  name: string;
  acceptedAnswer: string;
}
